export default class PvApiMethodNotAllowedException extends Error {
    constructor() {
        super();
        this.name = '405 method not allowed';
        this.message = 'Метод не поддерживается';
    }
}